export const EVENT_CALENDAR_MONTH_TITLE_FORMATTER = new Intl.DateTimeFormat("fr-FR", {
  month: "long",
  year: "numeric",
});

export const EVENT_CALENDAR_WEEKDAY_LABELS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

function padNumber(value: number) {
  return String(value).padStart(2, "0");
}

export function formatMonthKey(date: Date) {
  return `${date.getFullYear()}-${padNumber(date.getMonth() + 1)}`;
}

export function monthStartFromKey(monthKey: string) {
  const [year, month] = String(monthKey || "")
    .split("-")
    .map((part) => Number.parseInt(part, 10));

  if (!year || !month) {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  }

  return new Date(year, month - 1, 1);
}

export function shiftMonth(monthKey: string, offset: number) {
  const monthStart = monthStartFromKey(monthKey);
  return formatMonthKey(new Date(monthStart.getFullYear(), monthStart.getMonth() + offset, 1));
}

function startOfWeekMonday(date: Date) {
  const nextDate = new Date(date);
  const weekDay = (nextDate.getDay() + 6) % 7;
  nextDate.setDate(nextDate.getDate() - weekDay);
  return nextDate;
}

export function buildMonthCells(monthKey: string) {
  const monthStart = monthStartFromKey(monthKey);
  const gridStart = startOfWeekMonday(monthStart);

  return Array.from({ length: 42 }, (_, index) => {
    const date = new Date(gridStart);
    date.setDate(gridStart.getDate() + index);
    const iso = `${date.getFullYear()}-${padNumber(date.getMonth() + 1)}-${padNumber(date.getDate())}`;
    return {
      date,
      iso,
      isCurrentMonth: formatMonthKey(date) === monthKey,
    };
  });
}

export function preferredMonthKey(events: Array<{ date: string }>, todayIso: string) {
  const scheduledEvents = events.filter((event) => Boolean(String(event.date || "").trim()));
  const anchorEvent = scheduledEvents.find((event) => event.date >= todayIso) || scheduledEvents[0];
  if (anchorEvent?.date) {
    return anchorEvent.date.slice(0, 7);
  }
  return formatMonthKey(new Date());
}
